<template>
  <div id="manage-intent" v-if="intent">
    <div>
      <v-layout wrap style="border-bottom: 1px solid #eee" class="mb-3" v-if="!isWelcome">
        <v-flex
          xs12
          sm8
          md9
          form-control
          :class="{ 'has-error': errors.has('intentName') }"
          class="pa-2"
        >
          <input
            type="text"
            v-if="!isDefault"
            class="form-control"
            :placeholder="$t('Conversation')"
            v-model="intent.intentname"
            name="intentName"
            :data-vv-as="$t('Conversation')"
            aria-describedby="Intent Name"
            v-validate="
              'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
            "
          />
          <div v-else>
            <template v-if="intent.intentname == '{default_comment_to_inbox}'">
              <p>{{ $t('More Comment to Inbox') }}</p>
            </template>
            <template v-else>
              <p>{{ $t('Default Conversation') }}</p>
            </template>
          </div>
          <span class="text-error" v-show="errors.has('intentName')">{{
            errors.first('intentName')
          }}</span>
        </v-flex>
        <v-flex xs12 sm4 md3>
          <slot name="action"></slot>
          <div v-if="isReplyComment && isCommentToInbox" class="text-xs-right">
            <template v-if="$store.getters.getPackage == 'premium'">
              <v-btn color="primary" outline @click="showSelectPost = true">
                <template v-if="postidlist.length == 0">{{ $t('All post') }}</template>
                <template v-else
                  >{{ $t('post') }} ({{ postidlist.length }})</template
                >
                <v-icon class="ml-1">edit</v-icon>
              </v-btn>
              <intent-select-post
                v-model="intent.postidlist"
                :show="showSelectPost"
                @close="showSelectPost = false"
              ></intent-select-post>
            </template>

            <v-btn color="grey" disabled v-else outline>
              <template v-if="postidlist.length == 0">{{ $t('All post') }}</template>
              <template v-else
                >{{ $t('post') }} ({{ postidlist.length }})</template
              >
              <v-icon class="ml-1">edit</v-icon>
              <v-premium-lock></v-premium-lock>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1 pl-2 pr-2">
          <template v-if="!isDefault">
            <intent-question :q_images.sync="q_img" v-model="intent.q_val"></intent-question>
          </template>
          <template v-else>
            <p class="small" style="margin-bottom: 0px">
              <template v-if="intent.intentname == '{default}'"></template>
              <template v-else-if="intent.intentname == '{default_comment_to_inbox}'"></template>
            </p>
          </template>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <!-- <div class="hr show-on-small hide-on-med-and-up" style="margin: 15px -15px"></div> -->
          <template v-if="isReplyComment && isCommentToInbox">
            <intent-comment v-model="messages"></intent-comment>
          </template>
          <template v-else-if="isWelcome && !showMultipleChannel">
            <slot name="welcome" v-bind="{ showMultipleChannel, changeSetting }"></slot>
          </template>
          <template v-else>
            <v-layout>
              <v-flex
                v-if="showMultipleChannel"
                class="channel"
                shrink
                style="border-right: 1px solid #eee"
              >
                <template v-for="social in $store.state.socialChannelOptions">
                  <div
                    :class="{ 'primary white--text': tab == social.value }"
                    @click="tab = social.value"
                    class="py-1 pl-2 pr-2"
                    style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                    :key="`tab-${social.value}`"
                  >
                    <span :class="social.icon"></span>
                  </div>
                </template>
              </v-flex>
              <v-flex style="overflow: auto" :key="timestamp">
                <template v-if="!showMultipleChannel">
                  <intent-group
                    v-model="messages"
                    :intentname="intent.intentname"
                    :showMultipleChannel="showMultipleChannel"
                    :tab="tab"
                    @changeSetting="changeSetting"
                  ></intent-group>
                </template>
                <template v-else>
                  <template v-for="social in $store.state.socialChannelOptions">
                    <div v-show="social.value == tab" :key="`message-${social.value}`">
                      <intent-group
                        v-model="multiMessages[`${social.value}_messages`]"
                        :intentname="intent.intentname"
                        :showMultipleChannel="showMultipleChannel"
                        :tab="tab"
                        @changeSetting="changeSetting"
                      ></intent-group>
                    </div>
                  </template>
                </template>
              </v-flex>
            </v-layout>

            <template v-if="!isWelcome && !isCommentToInbox">
              <div class="hr"></div>
              <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>

              <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
                <tags
                  v-model="reply"
                  :tags="replies"
                  @tags-changed="addReplies"
                  @before-adding-tag="checkQuickReply"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add choice')"
                ></tags>
                <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorTag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </template>
            <template v-else></template>
          </template>
        </v-flex>
      </v-layout>

      <div class="mt-4">
        <div class="hr"></div>
        <div class="text-xs-center" style="margin: -13px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position: relative"
          >
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            ></i>
            <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
          </a>
        </div>

        <template>
          <div
            style="margin-top: 25px"
            v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
          >
            <v-tabs v-model="advancedTab" slider-color="primary" touchless>
              <v-tab :key="0" ripple>{{ $t('Customer') }}</v-tab>
              <v-tab :key="1" ripple>{{ $t('Context') }}</v-tab>
              <v-tab :key="2" ripple>{{ $t('Timer') }}</v-tab>
              <v-tab :key="3" ripple>{{ $t('Line Notify') }}</v-tab>
              <v-tab-item :key="0">
                <v-card
                  flat
                  :style="{
                    'min-height':
                      $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="form-control">
                      <div class="primary--text caption">{{ $t('Status') }}</div>
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('Status')"
                        v-model="intent.userstatus"
                        maxlength="600"
                      />
                    </div>
                    <div>
                      <div class="primary--text caption">{{ $t('Tag') }}</div>
                      <tags
                        v-model="usertag"
                        :tags="usertags"
                        @tags-changed="addUserTags"
                        @before-adding-tag="checkUserTags"
                        style="margin-bottom: 5px"
                        :btnText="$t('Add tag')"
                      ></tags>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-card
                  flat
                  :style="{
                    'min-height':
                      $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <v-layout>
                      <v-flex
                        class="form-control pr-1"
                        :class="{ 'has-error': errors.has('context_in') }"
                      >
                        <template v-if="isCommentToInbox">
                          <input
                            type="text"
                            class="form-control"
                            :value="$t('Comment')"
                            readonly
                            disabled
                          />
                        </template>
                        <template v-else>
                          <input
                            style="margin-bottom: 5px"
                            type="text"
                            class="form-control"
                            placeholder="Context In"
                            data-vv-as="Context In"
                            name="context_in"
                            v-model="intent.context_in"
                            v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                          />
                          <span class="text-error" v-show="errors.has('context_in')">{{
                            $t('Context In cannot be Comment')
                          }}</span>
                        </template>
                      </v-flex>
                      <v-flex class="form-control pl-1">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Context Out"
                          v-model="intent.context_out"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-card
                  flat
                  :style="{
                    'min-height':
                      $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <v-layout>
                      <v-flex>{{ $t('Turn On/Off Conversation') }}</v-flex>
                      <v-flex class="text-xs-right">
                        <label class="toggle-switch small" style="vertical-align: bottom">
                          <input
                            type="checkbox"
                            :checked="intent.intentstatus"
                            @change="onChangeIntentStatus()"
                          />
                          <span class="toggle-slider lever round"></span>
                        </label>
                      </v-flex>
                    </v-layout>
                    <v-divider class="mt-4 mb-4"></v-divider>
                    <v-layout>
                      <v-flex class="pr-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <v-layout wrap>
                            <v-flex
                              xs6
                              class="form-control"
                              :class="{ 'has-error': errors.has('startdate') }"
                            >
                              <v-menu
                                ref="openStartDate"
                                v-model="openStartDate"
                                :close-on-content-click="false"
                                full-width
                                max-width="290px"
                                color="primary"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Date')"
                                    readonly
                                    v-model="startDate"
                                    v-on="on"
                                    clearable
                                  />
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="startDate"
                                  @input="openStartDate = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 class="pl-1">
                              <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="startDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                    :disabled="startDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  startDate = null
                                  startTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                      <v-flex class="pl-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <v-layout wrap>
                            <v-flex
                              class="form-control"
                              xs6
                              :class="{ 'has-error': errors.has('enddate') }"
                            >
                              <v-menu
                                ref="openEndDate"
                                v-model="openEndDate"
                                :close-on-content-click="false"
                                full-width
                                max-width="290px"
                                color="primary"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Date')"
                                    readonly
                                    v-model="endDate"
                                    v-on="on"
                                    clearable
                                  />
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="endDate"
                                  @input="openEndDate = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 class="pl-1">
                              <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="endDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                    :disabled="endDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  endDate = null
                                  endTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>

                    <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                      <input
                        v-model="startTimeFormat"
                        type="hidden"
                        :data-vv-as="$t('Start date')"
                        name="startdate"
                        v-validate="endTimeFormat ? 'earlier' : ''"
                      />
                      <input
                        :data-vv-as="$t('End date')"
                        name="enddate"
                        v-model="endTimeFormat"
                        type="hidden"
                        ref="beforeTarget"
                      />

                      <span class="text-error" v-if="errors.has('startdate')">{{
                        errors.first('startdate')
                      }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="3">
                <v-card
                  flat
                  :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="col s8">
                      <div class="primary--text caption">{{ $t('Line Notify') }}</div>
                    </div>
                    <div class="col s4 right-align">
                      <template v-if="$store.state.linenotifylist.length == 0"></template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <label
                          class="toggle-switch small"
                          style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                        >
                          <input
                            type="checkbox"
                            :checked="intent.linenoti_status"
                            @change="toggleLineNotifyStatus"
                          />
                          <span class="toggle-slider lever round"></span>
                        </label>
                      </template>
                    </div>
                    <div class="col s12 form-control">
                      <template v-if="$store.state.linenotifylist.length == 0">
                        {{ $t('You are not connected to Line Notify.') }}
                        <router-link to="billing">{{
                          $t('Click to connected Line Notify at the settings page')
                        }}</router-link>
                      </template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('Message')"
                          maxlength="250"
                          v-model="intent.linenoti_text"
                        />
                      </template>
                      <template v-else>
                        {{ $t('Not yet alert via Line Notify.') }}
                        <router-link to="billing">{{
                          $t('Click to connected Line Notify at the settings page')
                        }}</router-link>
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </div>

      <div class="text-xs-center" style="margin-top: 35px; margin-bottom: 15px">
        <template>
          <input
            type="hidden"
            v-model="intent.q_val"
            v-validate="
              !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                ? 'required'
                : ''
            "
            :data-vv-as="$t('customer says')"
            name="q_val"
          />
          <div class="form-control has-error" style="margin-bottom: 10px">
            <span class="text-error" v-if="errors.has('intentName')">{{
              errors.first('intentName')
            }}</span>
            <span class="text-error" v-else-if="errors.has('q_val')">{{
              errors.first('q_val')
            }}</span>
            <span class="text-error" v-else-if="errors.has('bubbleLimit')">{{
              errors.first('bubbleLimit')
            }}</span>
            <span class="text-error" v-else-if="errorTag.length > 0">
              <template v-if="errorTag.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="errorTag.includes('overtagmax')">{{
                $t('Choices cannot be more than 10 items')
              }}</template>
              <template v-else-if="errorTag.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
            <span class="text-error" v-else-if="errors.has('context_in')">{{
              $t('Context In cannot be Comment')
            }}</span>
            <span class="text-error" v-else-if="errors.has('startdate')">{{
              errors.first('startdate')
            }}</span>
          </div>
          <slot name="footer" :saveIntent="saveIntent" :cancelEdit="cancelEdit">
            <div style="margin-bottom: 15px">
              <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                <i class="far fa-eye"></i>
                {{ $t('preview') }}
              </a>
              <preview-message
                v-if="showPreview"
                @close="showPreview = false"
                :messages="messages"
                :choice="replies"
                :questions="questions"
                :isComment="isCommentToInbox"
                :comment="replyComment"
              ></preview-message>
            </div>
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="saveIntent">{{ $t('Save') }}</v-btn>
          </slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import uploadfile from '@/components/elements/uploadfile'
import IntentGroup from './IntentGroup'
import IntentComment from './IntentComment'
import IntentGetstarted from './IntentGetstarted'
import Draggable from 'vuedraggable'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import IntentPrefill from './IntentPrefill'
import { Picker } from 'emoji-mart-vue'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalBlank from '@/components/elements/ModalBlank'
import Tags from '@/components/elements/Tags'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import PreviewMessage from '@/components/elements/PreviewMessage'
import IntentSelectPost from './IntentSelectPost'
import IntentQuestion from './IntentQuestion'
import moment from 'moment'
import { cloneDeep } from 'lodash'

import { VueAutosuggest } from 'vue-autosuggest'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'add'
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    isWelcome: {
      type: Boolean,
      default: false
    },
    excludedIntentName: {
      type: String,
      default: ''
    },
    isCommentToInbox: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueTagsInput,
    uploadfile,
    IntentGroup,
    IntentComment,
    IntentGetstarted,
    Draggable,
    GenericManage,
    MoveHorizontal,
    AutoresizeTextarea,
    IntentPrefill,
    Picker,
    ModalDialog,
    ModalBlank,
    Tags,
    PreviewMessage,
    ViewCartSummaryViewer,
    VueAutosuggest,
    IntentSelectPost,
    IntentQuestion
  },
  data: function() {
    return {
      q_img: [],
      advancedTab: null,
      showSelectPost: false,
      showAdvanced: false,
      showPreview: false,
      intent: undefined,

      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,

      tag: '',
      usertag: '',
      groups: [],
      generics: [],
      quick_reply: '',
      reply: '',
      text: '',
      messages: [[]],
      multiMessages: {},

      errorTag: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: '',
      showEmoji: false,
      excludedName: '',
      intents: [],

      selected: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'"
      },
      limit: 10,
      showMultipleChannel: false,
      tab: 'fb',
      timestamp: moment().format('x')
    }
  },
  created: function() {
    var vm = this
    vm.$validator.extend('earlier', {
      getMessage(field, val) {
        return vm.$t('The {field} must be before or equal.', { field: field })
      },
      validate(value, field) {
        if (vm.startTimeFormat || vm.endTimeFormat) {
          var isafter = moment(vm.startTimeFormat).isAfter(vm.endTimeFormat)
          return !isafter
        } else {
          return true
        }
      }
    })
  },
  mounted: function() {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)
    if (vm.value && vm.value.q_img) {
      vm.q_img = vm.value.q_img.split(',')
    }
    vm.intent = Object.assign({}, vm.value)
    vm.cached_intent = Object.assign({}, vm.value)

    if (vm.intent.starttime) {
      var startTime = moment(vm.intent.starttime)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = startTime.format('HH:mm')
    }
    if (vm.intent.endtime) {
      var endTime = moment(vm.intent.endtime)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = endTime.format('HH:mm')
    }

    vm.intents = vm.excludedIntentName.split(',')
    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    if (vm.isCommentToInbox) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    }

    const hasMultipleChannel = this.$store.state.socialChannelOptions.find(social => {
      return (
        Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`) &&
        this.intent[`${social.value}_val`]
      )
    })

    if (hasMultipleChannel) {
      this.showMultipleChannel = true
      this.$store.state.socialChannelOptions.forEach(social => {
        let json = [[]]
        try {
          json = Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`)
            ? JSON.parse(this.intent[`${social.value}_val`])
            : [[]]
        } catch (error) {
          console.error(error)
        }
        this.multiMessages[`${social.value}_messages`] = json
      })
      this.tab = hasMultipleChannel.value
    }

    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      var names = vm.intents
      $.each(names, function(index, name) {
        if (name === vm.intent.intentname) {
          names.splice(index, 1)
          return false
        }
      })

      vm.excludedName = names.join(',')
    } else {
      vm.excludedName = vm.intents.join(',')
    }

    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text
                    }
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
              ]
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ]
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val
                }
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: ''
                }
              ]
            }
          ]
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.value.a_type === 'text') {
        var newGroup = []
        var group = vm.value.a_val.split('||')
        $.each(group, function(index, messages) {
          var newMessage = []
          var groupMessages = messages.split('#nl')
          $.each(groupMessages, function(index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val
            }
          ]
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val)
            }
          ]
        ]
      } else if (vm.value.a_type === 'message') {
      } else if (vm.value.a_type === 'generic') {
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomeMessage: 'welcomeMessage',
      setting: 'setting',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab'
    }),
    tags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.q_val && vm.intent.q_val !== '') {
          var tags = vm.intent.q_val.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.intent.q_val = result.join(',')
      }
    },
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'quick_reply', result.join(','))
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.usertags && vm.intent.usertags !== '') {
          var usertags = []

          usertags = vm.intent.usertags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.intent.usertags = result.join(',')
      }
    },
    questions: function() {
      var result = []
      $.each(this.tags, function(index, val) {
        result.push(val.text)
      })
      return result
    },
    postidlist: function() {
      var vm = this
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        return vm.intent.postidlist.split(',')
      }
      return []
    },
    startTimeFormat: function() {
      var time = null
      var vm = this
      if (vm.startDate) {
        if (vm.startTime) {
          time = vm.startDate + ' ' + vm.startTime + ':00'
        } else {
          time = vm.startDate + ' 00:00:00'
        }
      }
      return time
    },
    endTimeFormat: function() {
      var time = null
      var vm = this
      if (vm.endDate) {
        if (vm.endTime) {
          time = vm.endDate + ' ' + vm.endTime + ':00'
        } else {
          time = vm.endDate + ' 23:59:00'
        }
      }
      return time
    }
  },
  methods: {
    async changeSetting(payload) {
      if (
        (this.$store.getters.getPackage == 'premium' ||
          this.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          this.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          let cloneMessages = null
          if (this.isWelcome) {
            try {
              await this.$nextTick()
              let { messages } = this.$store.getters.welcomeMessage('all')
              cloneMessages = messages
            } catch (error) {
              console.log(error)
            }
          } else {
            cloneMessages = this.messages
          }

          this.$store.state.socialChannelOptions.forEach(social => {
            if (social.value == 'fb' || social.value == 'ig') {
              this.$set(
                this.multiMessages,
                `${social.value}_messages`,
                cloneDeep(
                  cloneMessages.map(el => {
                    return el.filter(sel => {
                      return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                    }, [])
                  }, [])
                )
              )
            } else {
              this.$set(this.multiMessages, `${social.value}_messages`, cloneDeep(cloneMessages))
            }
            if (!this.isWelcome)
              this.$set(this.intent, `${social.value}_quick_reply`, this.intent.quick_reply)
          })
        }
        this.showMultipleChannel = payload.showMultipleChannel

        this.tab = this.showMultipleChannel ? 'fb' : 'all'
      }
    },
    toggleLineNotifyStatus: function() {
      this.intent.linenoti_status = !this.intent.linenoti_status
    },
    onShowAdvance: function() {
      this.showAdvanced = !this.showAdvanced
      // if (this.$store.getters.getPackage === 'premium') {
      // }
    },
    addGeneric: function() {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: [],

        enable: true
      })
    },
    saveIntent: function() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.intent.intentname,
        q_type: vm.intent.q_type,
        q_val: vm.intent.q_val,
        a_type: 'json',
        a_val: vm.intent.a_val,
        quick_reply: vm.intent.quick_reply,
        postidlist: vm.intent.postidlist,
        isShow: true,
        intentstatus: vm.intent.intentstatus
      }
      if (vm.q_img && vm.q_img.length) {
        Object.assign(data, { q_img: vm.q_img.join(',') })
      }
      if (vm.$store.getters.getPackage == 'premium') {
        ;(data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''),
          (data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''),
          (data.userstatus = vm.intent.userstatus),
          (data.usertags = vm.intent.usertags),
          (data.linenoti_status = vm.intent.linenoti_status),
          (data.linenoti_text = vm.intent.linenoti_text),
          (data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null),
          (data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null)
      } else {
        ;(data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''),
          (data.context_out =
            vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''),
          (data.userstatus = vm.cached_intent.userstatus),
          (data.usertags = vm.cached_intent.usertags),
          (data.linenoti_status = vm.cached_intent.linenoti_status),
          (data.linenoti_text = vm.cached_intent.linenoti_text),
          (data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null),
          (data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null)
      }

      if (this.showMultipleChannel) {
        this.$store.state.socialChannelOptions.forEach(social => {
          data[`${social.value}_val`] = JSON.stringify(
            this.multiMessages[`${social.value}_messages`]
          ).replace(/ /gim, ' ')

          data[`${social.value}_quick_reply`] = this.intent[`${social.value}_quick_reply`]
        })
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox) {
          var message = []
          if (vm.messages) {
            vm.messages.map(function(m, index) {
              if (
                (m[0].replyinbox === true &&
                  m[0].responseinbox[0].text !== '' &&
                  m[0].responseinbox[0].text !== null) ||
                (m[0].replycomment === true &&
                  m[0].responsecomment[0].text !== '' &&
                  m[0].responsecomment[0].text !== null) ||
                m[0].hidecomment === true
              ) {
                if (m[0].replyinbox === true && m[0].responseinbox[0].type === 'generic') {
                  m[0].responseinbox[0].data = m[0].responseinbox[0].data.filter(v => {
                    return v.image_url || v.title || v.subtitle
                  })
                }
                message.push(m)
              }
            })
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message)
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          var messages = []
          $.each(vm.messages, function(index, message) {
            var group = []
            $.each(message, function(mindex, msg) {
              if (msg.type === 'text') {
                if (msg.text !== '' && msg.text != null) {
                  group.push(msg)
                }
              } else if (msg.type === 'button') {
                if ((msg.text !== '' && msg.text != null) || msg.buttons.length > 0) {
                  group.push(msg)
                }
              } else if (msg.type === 'image') {
                if (msg.image_url) {
                  group.push(msg)
                }
              } else if (msg.type === 'generic') {
                var generics = []
                $.each(msg.data, function(gindex, generic) {
                  // console.log('filter', generic)
                  if (
                    generic.image_url != null ||
                    generic.title !== '' ||
                    generic.subtitle !== '' ||
                    (typeof generic.productid != 'undefined' && generic.productid != null) ||
                    generic.buttons.length > 0
                  ) {
                    // console.log(generic)
                    generics.push(generic)
                  }
                })
                if (generics.length > 0) {
                  group.push({
                    type: 'generic',
                    data: generics
                  })
                }
              } else if (msg.type === 'flex') {
                if (msg.contents !== '' && msg.contents != null) {
                  group.push(msg)
                }
              } else {
                group.push(msg)
              }
            })
            if (group.length > 0) {
              messages.push(group)
            }
          })

          if (messages.length === 0) {
            messages = [[]]
          }

          data.a_val = JSON.stringify(messages)
        }
      }

      vm.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }
          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            api.addIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              data.id = response.id
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.$emit('close', null)
              vm.$store.dispatch('loading')
              vm.intent = {
                intentname: '',
                q_type: 'text',
                a_type: 'json',
                q_val: '',
                a_val: [[]],
                context_in: '',
                context_out: '',
                postidlist: ''
              }
              vm.cached_intent = Object.assign({}, vm.intent)
            })
          } else {
            data['id'] = vm.intent.id
            vm.$store.dispatch('loading')
            api.editIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.cached_intent = Object.assign({}, vm.intent)

              vm.$store.dispatch('loading')
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancelEdit: function() {
      var vm = this
      vm.intent = Object.assign({}, vm.cached_intent)
      vm.$emit('close', null)
    },
    checkTag(obj) {
      this.errorQuestionTag = []
      if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorQuestionTag.push('duplicate')
        obj.error()
      } else obj.addTag()

      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
    },
    checkQuickReply(obj) {
      // console.log(obj)
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else
      // console.log('hi' ,obj)
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.replies.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1)
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    onChangeReplyComment: function() {
      if (this.isReplyComment) {
        this.intent.context_in = 'comment'
        this.replyComment = ''
      } else {
        this.intent.context_in = ''
        this.replyComment = ''
      }
    },
    onChangeIntentStatus: function() {
      this.intent.intentstatus = !this.intent.intentstatus
      this.$set('intent', 'intentstatus', !this.intent.intentstatus)
    },
    addIntentPrefill: function(prefill) {
      var vm = this
      let cursorPosition = this.$refs.replyComment.$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.replyComment.slice(cursorPosition)
      ].join('')
    },
    addEmoji: function(emoji) {
      var vm = this
      let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition)
      ].join('')
      vm.showEmoji = false
    },
    changeIntentType: function(type) {
      var vm = this
      if (type == 'text' && (vm.intent.a_type == '' || vm.intent.a_type == null)) {
        this.text = this.intent.a_val
      }

      if (vm.intent.a_type == 'text') {
        this.text = this.intent.a_val
      }

      if (type == 'text') {
        this.intent.a_val = this.text
      }
      vm.intent.a_type = type
    },
    addReplies: function(newTags) {
      this.replies = newTags
      // console.log(newTags,this.replies)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    onSelected(option) {
      this.selected = option.item
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter(item => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1
        })
        .slice(0, this.limit)

      this.filteredOptions = [
        {
          data: filteredData
        }
      ]
    }
  },
  watch: {
    showPreview: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    'intent.context_in': function(newVal, oldVal) {
      if (newVal == 'comment') {
        this.isReplyComment = true
      } else {
        this.isReplyComment = false
      }
    },
    value: function(newVal, oldVal) {
      var vm = this
      vm.intent = Object.assign({}, vm.value)
      vm.cached_intent = Object.assign({}, vm.value)
      if (vm.intent.starttime) {
        var startTime = moment(vm.intent.starttime)
        vm.startDate = startTime.format('YYYY-MM-DD')
        vm.startTime = startTime.format('HH:mm')
      }
      if (vm.intent.endtime) {
        var endTime = moment(vm.intent.endtime)
        vm.endDate = endTime.format('YYYY-MM-DD')
        vm.endTime = endTime.format('HH:mm')
      }

      if (vm.value.a_type == 'text') {
      }

      if (vm.value.a_type == 'template') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val)
        } else {
          vm.generics = []
        }
      }

      if (vm.value.a_type == 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.messages = JSON.parse(vm.value.a_val)
        } else {
          vm.messages = []
        }
      }

      if (vm.value.context_in == 'comment') {
        vm.replyComment = vm.value.a_val
      }
    },
    excludedIntentName: function() {
      var vm = this
      vm.intents = vm.excludedIntentName.split(',')
      vm.intents.push('comment')
      vm.intents.push('{default}')
      vm.intents.push('{welcome}')
      vm.intents.push('{default_comment_to_inbox}')

      if (vm.type == 'edit' && vm.excludedIntentName && vm.excludedIntentName != '' && vm.intent) {
        var result = []
        var names = vm.intents
        $.each(names, function(index, name) {
          if (name == vm.intent.intentname) {
            names.splice(index, 1)
            return false
          }
        })

        vm.excludedName = names.join(',')
      } else {
        vm.excludedName = vm.intents.join(',')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue